const part = [
    {
        path: 'product-list',
        name: 'product-list',
        meta: {
            icon: 'md-cube',
            title: '产品管理',
            notCache: false,
            access: ['B', 'C', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/product-management/product-list')
    }
];

export default part;
